/* Font level 1 */
.host {
  color: var(--color-semantic-text-neutral30);
  font-weight: bold;
  font-size: 3.2rem;
  line-height: 4rem;
}

/* Font Level 0 */
.host.large {
  font-size: 4rem;
  line-height: 4.8rem;
}

/* Font level 2 */
.host.small {
  font-size: 2rem;
  line-height: 2.4rem;
}
